<template>
  <div class="mgl-10px">
    <div class="card-article-input-selectDateVente columns is-vcentered">
      <div class="has-text-centered is-paddingless"
           :class="[getDatePickerColor, {'disabled': disabled}]">
        <a @click="showModalChangeDate = true">
          <b-icon
            icon="calendar-clock"
            type="is-white"
            custom-class="mgt-10px">
          </b-icon>
        </a>
      </div>
      <div class="card-article-input-dateRegroup has-text-icon-more
      is-size-7 column is-narrow is-paddingless">
        {{ getDate() }}
      </div>
      <div class="card-article-input-dayRegroup
    has-text-icon-more is-size-7" v-if="getNumberDay">
        {{ $t('detail.article.numberDays', { nbJour: getNumberDay }) }}
      </div>
    </div>
    <b-modal v-model="showModalChangeDate" has-modal-card class="modal">
      <pop-up-change-date-regroupement :ligne-regroupement="ligneRegroupement">
      </pop-up-change-date-regroupement>
    </b-modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';
import popUpChangeDateRegroupement
  from '@/components/devisCommandes/editionDevisCommande/specLigneArticle/popUpChangeDateRegroupement';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';

export default {
  name: 'produitRegroupementProduitPresse',
  props: {
    ligneRegroupement: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    popUpChangeDateRegroupement,
  },
  data() {
    return {
      showModalChangeDate: false,
    };
  },
  methods: {
    getDate() {
      if (!this.ligneRegroupement.dateDebut && !this.ligneRegroupement.dateFin) return '';
      if (this.ligneRegroupement.dateDebut && !this.ligneRegroupement.dateFin) {
        return this.$t('detail.article.dateDebut', { dateDebut: formatDate(this.ligneRegroupement.dateDebut) });
      }
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneRegroupement.dateDebut), dateFin: formatDate(this.ligneRegroupement.dateFin) });
    },
  },
  mounted() {
    this.showModalChangeDateLocation = cloneDeep(this.ouverturePopup);
  },
  computed: {
    getDatePickerColor() {
      if (!this.ligneRegroupement.dateDebut || !this.ligneRegroupement.dateFin) {
        return 'card-article-input-datepicker-warning';
      }
      return 'card-article-input-datepicker-success';
    },
    getNumberDay() {
      const dateDebut = this.ligneRegroupement.dateDebut;
      const dateFin = this.ligneRegroupement.dateFin;
      if (dateDebut && dateFin) return Number(calculDaysBetweenTwoDate(dateFin, dateDebut)) + 1;
      return null;
    },
  },
};
</script>

<style scoped>

</style>
